import { css, type Theme } from "@emotion/react";

export const pill = css`
  white-space: nowrap;
  gap: 0.5rem;
  svg {
    height: 12px;
  }
`;

export const iconWrapper = {
  base: (theme: Theme) => css`
    background: ${theme.success.backgroundMuted};
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    position: relative;
  `,

  xsmall: css`
    width: 1rem;
    height: 1rem;
  `,
};

export const icon = {
  base: (theme: Theme) => css`
    path {
      fill: ${theme.success.textBase};
    }

    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);

    width: 15px;
  `,
  xsmall: css`
    width: 10px;
  `,
};

export const iconTooltip = css`
  height: 40px;
  width: 40px;

  div {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
  }
`;
